import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import React, { useEffect, useMemo, useRef, useState} from "react";
import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import {KitchenType} from "../../../api";
import _ from "lodash";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

interface KitchenCatalogProps extends WithStyles<typeof styles> {
    disabled: boolean;
    kitchenTypes: KitchenType[];
    chosenTypes: string[];
    onChange: (value: string[]) => void;
}

const styles = (theme: Theme) => createStyles({
    formControl: {
        width: '100%',
        '& .MuiInput-underline:before': {
            borderBottom: 'none !important'
        },
        '& .MuiInput-underline:after': {
            borderBottom: 'none !important'
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            borderBottom: 'none !important'
        },
        '& .MuiSelect-select' : {
            height: '20px',
            boxSizing: 'border-box',
            lineHeight: '20px',
            padding: '0',
            paddingRight: '20px'
        },
        '& .MuiSelect-select:focus' : {
            backgroundColor: '#fff'
        },
        '& .MuiSelect-icon': {
            marginRight: '16px'
        }
    },
    select: {
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: '4px',
        padding: '8px 12px',
        '&:focus': {
            borderRadius: '4px',
            backgroundColor: '#fff',
        },
    },
    kitchenContainer: {
        marginTop: '16px'
    },
    menuItem: {
        paddingTop: '8px',
        paddingBottom: '8px',
        '&.Mui-selected': {
            color: '#6AE8C5',
        },
        '&.Mui-selected:hover': {
            color: '#6AE8C5',
        }
    }
});

function KitchenCatalog(props: KitchenCatalogProps) {
    const { classes, disabled, chosenTypes, kitchenTypes, onChange } = props;
    const [value, setValue] = useState(props.chosenTypes || []);
    const prevValue = useRef(value);

    useEffect(() => {
        setValue(chosenTypes)
    },[chosenTypes])

    const getKitchenTypeList = useMemo(() => {
        let kitchenTypeList = ''

        if (kitchenTypes && value) {
            value.forEach(function (chosenType, index) {
                const type = kitchenTypes.find(kitchenType => kitchenType.type === chosenType)
                if (type) {
                    kitchenTypeList += index !== 0 ? `, ` : ''
                    kitchenTypeList += type.name
                }
            });
        }
        return kitchenTypeList
    },[value, kitchenTypes])

    const handleClose = () => {
        if (!_.isEqual(_.sortBy(value), _.sortBy(prevValue.current))) {
            onChange(value)
            prevValue.current = value;
        }
    };

    const handleOpen = () => {
        prevValue.current = value;
    };

    const handleChange = (event: any) => {
        setValue(event.target.value);
    }

    return (
        <div className={classes.kitchenContainer}>
            <span style={disabled ? { color: 'rgba(10, 25, 35, 0.4)'} : {color: 'rgba(10, 25, 35, 0.9)'}}>Кухня</span>
            <FormControl className={classes.formControl} >
                <Select
                    multiple
                    disabled={disabled}
                    className={classes.select}
                    value={value}
                    onOpen={handleOpen}
                    renderValue={() => (
                        <div style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            lineHeight: '20px',
                        }}>
                            {getKitchenTypeList}
                        </div>
                    )}
                    IconComponent={(props) =>
                        props.open ? <ExpandLess {...props} /> : <ExpandMore {...props} />
                    }
                    onClose={handleClose}
                    onChange={handleChange}
                >
                    {kitchenTypes  && kitchenTypes.length > 0  && kitchenTypes.map(item => (
                        <MenuItem
                            className={classes.menuItem}
                            key={item.type}
                            value={item.type}
                        >
                            {item.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}

export default withStyles(styles, { withTheme: true })(KitchenCatalog);